import { Radio, Space } from 'antd';
import { FormRadio, FormWrapper } from 'components/form';
import { useTranslation } from 'react-i18next';
import { useClaimPropertiesContext } from '../../../contexts/claimProperties';
import { useCachedClaimProperties } from '../../../hooks';
import { useEffect, useState } from 'react';

interface Patient {
  label: string;
  value: string;
}
export const PatientSelect = () => {
  const { t } = useTranslation();

  const { key: claimPropertiesKey } = useClaimPropertiesContext();
  const { data: claimProperties } = useCachedClaimProperties(claimPropertiesKey);
  const [patients, setPatients] = useState<Patient[]>([]);

  useEffect(() => {
    const patientsData: Patient[] =
      claimProperties?.familyMembers?.map(({ memberType, firstName, lastName }) => ({
        label: `${firstName} ${lastName}`,
        value: memberType ?? '',
      })) ?? [];
    setPatients(patientsData);
  }, [claimProperties]);

  return (
    <FormWrapper
      name="patientName"
      label={t('preAuthRequest.requestInformation.patient.label')}
      secondaryText={t('preAuthRequest.requestInformation.patient.placeholder')}
    >
      <FormRadio name="patientName">
        <Space direction="vertical">
          {patients.map(({ label, value }) => (
            <Radio key={value} value={value}>
              {label}
            </Radio>
          ))}
        </Space>
      </FormRadio>
    </FormWrapper>
  );
};
